<template>
  <img
    src="/assets/images/shared/favicon.png"
    alt="Green Core Logo"
    class="mark"
  />
</template>

<style scoped>
.mark {
  display: block;
  width: 32px;
  aspect-ratio: 1;
}
</style>
